var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 4.25879H15.5L14.5 3.25879H9.5L8.5 4.25879H5V6.25879H19M6 19.2588C6 19.7892 6.21071 20.2979 6.58579 20.673C6.96086 21.0481 7.46957 21.2588 8 21.2588H16C16.5304 21.2588 17.0391 21.0481 17.4142 20.673C17.7893 20.2979 18 19.7892 18 19.2588V7.25879H6V19.2588Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.8096e7e143c8b0f96815d8652186856a.svg";
export { ForwardRef as ReactComponent };